<template>  
  <div id="app">  
    <router-view />  
  </div>  
</template>  
<script>  
import MessageAlert from './components/MessageAlert.vue';   
import api from '@/api'
export default {  
  name: 'App',  
  components: {  
    MessageAlert,
  },  
  data() {  
    return {  
      intervalId: null,  
      messages: [],  
      isLoginPage: false  
    };  
  },  
  // watch: {  
  //   $route: {
  //     handler: function(to) {
  //       // 判断是否登录页，如果不是则启动定时器
  //       this.isLoginPage = to.name === 'login';
  //       if (this.intervalId) {
  //         clearInterval(this.intervalId);
  //       }
  //       if (!this.isLoginPage) {
  //         this.startFetchingMessages();
  //       }else{
  //         if(this.$refs.messageAlert){
  //           this.$refs.messageAlert.mCloseMessage(false);
  //         }
  //       }
  //     },
  //     immediate: true,
  //   }
  // },  
  mounted() {  
    // 判断是否登录页，如果不是则启动定时器  
    // this.$router.afterEach((to) => {  
    //   this.isLoginPage = to.name === 'login';  
    //   // if (!this.isLoginPage) {  
    //   //   this.startFetchingMessages();  
    //   // }  
    // });  
  },  
  beforeDestroy() {  
    // 清除定时器  
    if (this.intervalId) {  
      clearInterval(this.intervalId);  
    }  
    // 关闭弹窗  
    if (this.$refs.messageAlert && this.$refs.messageAlert.showAlert) {  
      this.$refs.messageAlert.showAlert = false;  
    }  
  },  
  methods: {  
    startFetchingMessages() {  
      this.intervalId = setInterval(() => {  
        this.$axios.get(api.GetMsg)  
          .then(res => {  
            // const newMessages = res.data.msg.filter(msg => !this.messages.some(m => m.id === msg.id));  
            // if (newMessages.length > 0) {  
            //   // alert('接口有返回值')
            //   this.isLoginPage = true 
            //   this.showNextMessage(newMessages);  
            //   this.messages = this.messages.concat(newMessages);  
            // }  
            console.log('请求获取到的数据为：',res.data.msg)
            if (res.data.msg.length > 0) {
              // this.isLoginPage = true
              this.showNextMessage(res.data.msg);
            }
          })  
          .catch(err => {  
            console.error('获取消息失败', err);  
          });  
      }, 60000); // 每2分钟请求一次  
    },  
    showNextMessage(messages) {  
      if (messages.length > 0) {  
        this.isLoginPage = true 
        const msg = messages.shift(); 
        // alert('执行数据回传')
        this.$refs.messageAlert.showMessage(msg);  
      }  
    },  
    handleCloseAlert() {  
      // 可以在这里处理关闭弹窗后的逻辑，如重置某些状态  
    }  
  }  
};  
</script>  
<style lang="less">  
/* ... your styles here ... */  
</style>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  line-height: inherit  !important; 
}
.bx {
  width:1200px;
  margin: 0 auto;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
i {
  font-style: normal;
}

// .el-dialog{
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%);
//         background:transparent;
//         padding:0;
//         box-shadow: none;
//         .el-dialog__header{
//             display: none;
//         }
//         .el-dialog__body{
//             padding:0;
//         }
// }
</style>



// WEBPACK FOOTER //
// src/App.vue